import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    mraMsg: [],
    mcaFeedback: null,
    commandStack: [],
    isProcessingCommand: false,
    eligibilityPrompt: null,
    voiceRecordingPromptData: null,
    activeCategoryMenu: null,
};
export const messagingSlice = createSlice({
    name: "messaging",
    initialState,
    reducers: {
        setMraMessage(state, action) {
            state.mraMsg = action.payload;
        },
        setMcaFeedback(state, action) {
            state.mcaFeedback = action.payload;
        },
        setIsProcessingCommand(state, action) {
            state.isProcessingCommand = action.payload;
        },
        pushCommand(state, action) {
            state.commandStack.push(action.payload);
            state.commandStack = state.commandStack.slice(-10);
        },
        setCommandStack(state, action) {
            state.commandStack = action.payload;
        },
        setEligibilityPrompt(state, action) {
            state.eligibilityPrompt = action.payload;
        },
        setActiveCategoryMenu(state, action) {
            state.activeCategoryMenu = action.payload;
        },
        setVoiceRecordingPromptData(state, action) {
            state.voiceRecordingPromptData = action.payload;
        },
    },
});
export const messagingReducer = messagingSlice.reducer;
export const { setIsProcessingCommand, setMcaFeedback, setMraMessage, pushCommand, setEligibilityPrompt, setVoiceRecordingPromptData, setActiveCategoryMenu, } = messagingSlice.actions;
export const mcaFeedbackSelector = (state) => state.messaging.mcaFeedback;
export const mraMsgSelector = (state) => state.messaging.mraMsg;
export const isProcessingCommandSelector = (state) => state.messaging.isProcessingCommand;
export const eligibilityPromptSelector = (state) => state.messaging.eligibilityPrompt;
export const activeCategoryMenuSelector = (state) => state.messaging.activeCategoryMenu;
export const voiceRecordingPromptDataSelector = (state) => state.messaging.voiceRecordingPromptData;
//# sourceMappingURL=messagingSlice.js.map